export default function Game_Sound() {
  return (
    <div>
      <h1>Game_Sound Component</h1>
    </div>
  );
}
